// extracted by mini-css-extract-plugin
export default {"page-title-area":"styles_page-title-area__ZSjXc","page-title":"styles_page-title__u9C4A"};